import { meta } from '@/helpers/constants/router';
import { OVERVIEW_ROUTE, PERFORMANCE_ROUTE, CAMPAIGN_ROUTE, BROADCAST_ROUTE, CUSTOMER_SEGMENT_ROUTE, ACTIVITY_ROUTE, WINNERS_ROUTE, RAFFLE_DRAW_ROUTE, REFERRALS_ROUTE, } from '@/helpers/constants/SurveyRoutes';
// lazy load components
// https://router.vuejs.org/guide/advanced/lazy-loading.html
const Wrapper = () => import('@/views/Wrapper.vue');
const ComingSoon = () => import('@/views/v2/ComingSoon.vue');
export default [
    {
        path: 'survey',
        component: Wrapper,
        meta: { ...meta, title: 'Survey' },
        children: [
            {
                path: '/',
                component: Wrapper,
            },
            {
                path: 'overview',
                component: Wrapper,
                meta: { ...meta, title: 'Overview' },
                children: [
                    {
                        path: '/',
                        name: OVERVIEW_ROUTE.name,
                        component: () => import('@/views/v2/survey/Overview.vue'),
                        meta: { title: OVERVIEW_ROUTE.title },
                    },
                    {
                        path: 'performance',
                        name: PERFORMANCE_ROUTE.name,
                        component: () => import('@/views/v2/survey/Performance.vue'),
                        meta: { title: PERFORMANCE_ROUTE.title },
                    },
                ],
            },
            {
                path: 'campaign',
                component: Wrapper,
                meta: { ...meta, title: CAMPAIGN_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: CAMPAIGN_ROUTE.name,
                        component: ComingSoon,
                        meta: { title: CAMPAIGN_ROUTE.title },
                    },
                ],
            },
            {
                path: 'raffle-draw',
                component: Wrapper,
                meta: { ...meta, title: RAFFLE_DRAW_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: RAFFLE_DRAW_ROUTE.name,
                        component: () => import('@/views/v2/survey/CampaignRaffles.vue'),
                        meta: { title: RAFFLE_DRAW_ROUTE.title },
                    },
                    {
                        path: 'create',
                        name: 'New Raffle',
                        component: () => import('@/views/v2/survey/CampaignRaffleCreate.vue'),
                        meta: { title: 'New Raffle' },
                    },
                    {
                        path: ':uuid',
                        meta: { title: 'Raffle' },
                        component: Wrapper,
                        children: [
                            {
                                path: 'details',
                                name: 'raffle-draw-details',
                                component: () => import('@/views/v2/survey/CampaignRaffleDetails.vue'),
                                props: true,
                                meta: {
                                    title: 'Raffle',
                                    parentMenu: 'raffle-draw',
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'broadcast',
                component: Wrapper,
                meta: { ...meta, title: BROADCAST_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: BROADCAST_ROUTE.name,
                        component: () => import('@/views/v2/Broadcast.vue'),
                        meta: { title: BROADCAST_ROUTE.title },
                    },
                ],
            },
            {
                path: 'survey-customer-segment',
                component: Wrapper,
                meta: { ...meta, title: CUSTOMER_SEGMENT_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: CUSTOMER_SEGMENT_ROUTE.name,
                        component: () => import('@/views/v2/survey/CustomerSegmentation.vue'),
                        meta: { title: CUSTOMER_SEGMENT_ROUTE.title },
                    },
                ],
            },
            {
                path: 'activities',
                component: Wrapper,
                meta: { ...meta, title: ACTIVITY_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: ACTIVITY_ROUTE.name,
                        component: () => import('@/views/v2/survey/Activity.vue'),
                        meta: { title: ACTIVITY_ROUTE.title },
                    },
                ],
            },
            {
                path: 'winners',
                component: Wrapper,
                meta: { ...meta, title: WINNERS_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: WINNERS_ROUTE.name,
                        component: () => import('@/views/v2/survey/Winner.vue'),
                        meta: { title: WINNERS_ROUTE.title },
                    },
                ],
            },
            {
                path: 'referrals',
                component: Wrapper,
                meta: { ...meta, title: REFERRALS_ROUTE.title },
                children: [
                    {
                        path: '/',
                        name: REFERRALS_ROUTE.name,
                        component: () => import('@/views/v2/survey/Referral.vue'),
                        meta: { title: REFERRALS_ROUTE.title },
                    },
                ],
            },
            {
                path: 'notifications',
                name: 'survey-notifications',
                component: () => import('@/views/v2/NotificationsManager.vue'),
                meta: { ...meta, title: 'Notification Manager' },
                redirect: { name: 'survey-notifications-manager-email' },
                children: [
                    {
                        path: 'fb-messenger',
                        name: 'survey-notifications-manager-fb-messenger',
                        meta: { title: 'Notification Manager', parentMenu: 'survey-notifications' },
                        component: () => import('@/views/v2/NotificationsFbMessenger.vue'),
                    },
                    {
                        path: 'email',
                        name: 'survey-notifications-manager-email',
                        meta: { title: 'Notification Manager', parentMenu: 'survey-notifications' },
                        component: () => import('@/views/v2/NotificationsEmail.vue'),
                    },
                ],
            },
        ],
    },
];
